import type { StateCreator } from 'zustand';

export interface ConfigSlice {
	// Static configuration (set once at initialization)
	formId: number;
	bookingFieldId: number;
	serviceFieldId: number | null; // For monitoring service field changes
	resourceFieldIds: number[];
	slotMode: 'aligned' | 'flexible';
	interval: number;
	showEndTimes: boolean;
	showTimezoneIndicator: boolean;
	timezoneMessage: string | null;
	showSpotsLeft: boolean;
	spotsLeftText: string | null;
	showUserTimezone: boolean;
	showTwoMonths: boolean;
	startingMonthMode: 'first_availability_window' | 'current' | 'specific';
	startingMonth: number | null;
	startingYear: number | null;
	displayMode: 'calendar' | 'simple';
	simpleLimit: number;
	excludeBookingId: number | null; // For excluding a booking from availability checks (e.g., when rescheduling or editing)
	isEntryEdit: boolean; // Whether we're in entry edit mode

	// Actions
	setConfig: (config: {
		formId: number;
		bookingFieldId: number;
		serviceFieldId: number | null;
		resourceFieldIds: number[];
		slotMode: 'aligned' | 'flexible';
		interval: number;
		showEndTimes: boolean;
		showTimezoneIndicator: boolean;
		timezoneMessage: string | null;
		showSpotsLeft: boolean;
		spotsLeftText: string | null;
		showUserTimezone: boolean;
		showTwoMonths: boolean;
		startingMonthMode: 'first_availability_window' | 'current' | 'specific';
		startingMonth: number | null;
		startingYear: number | null;
		displayMode?: 'calendar' | 'simple';
		simpleLimit?: number;
		excludeBookingId?: number | null;
		isEntryEdit?: boolean;
	}) => void;
	setExcludeBookingId: (bookingId: number | null) => void;
	setIsEntryEdit: (isEntryEdit: boolean) => void;
}

export const createConfigSlice: StateCreator<ConfigSlice> = (set) => ({
	formId: 0,
	bookingFieldId: 0,
	serviceFieldId: null,
	resourceFieldIds: [],
	slotMode: 'aligned',
	interval: 0,
	showEndTimes: true,
	showTimezoneIndicator: true,
	timezoneMessage: null,
	showSpotsLeft: false,
	spotsLeftText: null,
	showUserTimezone: false,
	showTwoMonths: false,
	startingMonthMode: 'first_availability_window',
	startingMonth: null,
	startingYear: null,
	displayMode: 'calendar',
	simpleLimit: 20,
	excludeBookingId: null,
	isEntryEdit: false,

	setConfig: (config) => set(config),
	setExcludeBookingId: (bookingId) => set({ excludeBookingId: bookingId }),
	setIsEntryEdit: (isEntryEdit) => set({ isEntryEdit }),
});
